import { memo } from 'react';
import { Alert, AlertTitle, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export interface ErrorAlertProps {
  error: string | null;
  title?: string;
  onDismiss?: () => void;
}

/**
 * Reusable error alert component
 */
export const ErrorAlert = memo<ErrorAlertProps>(({
  error,
  title,
  onDismiss,
}) => {
  if (!error) return null;

  return (
    <Alert
      severity="error"
      sx={{ mb: 2 }}
      action={
        onDismiss && (
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onDismiss}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )
      }
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {error}
    </Alert>
  );
});

ErrorAlert.displayName = 'ErrorAlert';

export default ErrorAlert;
